import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminForecastApi = lazy(() => import("@/pages/admin/AdminForecastApi"));

export const Route = createFileRoute("/admin/prognos-api")({
  component: () => <AdminForecastApi />,
});
